import classNames from 'classnames';
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import WrappedIntlComponent from '../../common/intl/WrappedIntlComponent';
import Submenu from '../../common/Submenu';
import Wrapper from '../../common/Wrapper';
import {getReferals} from './actions';
import { Table } from 'antd';
import './style.scss'
import { toastr } from 'react-redux-toastr';

export class Referals extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  constructor(props) {
    super(props)
    this.state = {
      spinner: true,
      users: [],
      user: {},
    }
  }

  async componentDidMount(){
    const data = await getReferals();
    this.setState({
      spinner: false,
      ...data
    })
  }

  copyToClipboard = (text) => {
    const {formatMessage} = this.props;
    var textField = document.getElementById('referal')
    textField.select()
    document.execCommand('copy')
    toastr.success(formatMessage('txtLinkRef'), formatMessage('txtLinkRefMsg'))
  }

  render() {
    const {formatMessage} = this.props;
    const { spinner, users, user } = this.state;
    const columns = [
      {
        title: formatMessage('First name'),
        dataIndex: 'firstname',
        key: 'firstname',
      }, 
      {
        title: formatMessage('Last name'),
        dataIndex: 'lastname',
        key: 'lastname',
      }, 
      {
        title: formatMessage('Email'),
        dataIndex: 'email',
        key: 'email',
      },
    ];

    

    return (
      <Wrapper renderButtonNav = {false}>
          <div className="container content flex-column container-support-wrapper">
              <Submenu />
                <div className='Referals'>
                  <div className='row'>
                    <div className='col-md-12'>
                      <div className='block-ref'>
                        <label>{formatMessage('youReferalLink')}</label>
                        <div>
                          <input id='referal' value={window.location.origin + '/auth/signup?referal_code=' + user.referal_code} readOnly />
                          <button onClick={this.copyToClipboard}><i className="fa fa-clone" aria-hidden="true"></i></button>
                        </div>
                      </div>
                      <Table loading={spinner} dataSource={users} columns={columns} bordered />
                    </div>
                  </div>
                  
                </div>
            
          </div>
      </Wrapper>
    )
  }
}

export default WrappedIntlComponent(Referals);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Referals/Referals.jsx